import CalvinService from '../../services/calvin'

export const state = {}

export const mutations = {}

export const getters = {}

export const actions = {
	// eslint-disable-next-line no-unused-vars
	init({ state, dispatch }) {},

	// eslint-disable-next-line no-unused-vars
	getCalvinWorkspaces({ commit }, payload) {
		return new Promise((resolve, reject) => {
			CalvinService.getCalvinWorkspaces(payload).then(response => {
				resolve(response.data)
			}).catch(error => { reject(error) })
		})
	},

	// eslint-disable-next-line no-unused-vars
	getCalvinWorkspace({ commit }, payload) {
		return new Promise((resolve, reject) => {
			CalvinService.getCalvinWorkspace(payload).then(response => {
				resolve(response.data)
			}).catch(error => { reject(error) })
		})
	},

	// eslint-disable-next-line no-unused-vars
	getCalvinChats({ commit }, payload) {
		return new Promise((resolve, reject) => {
			CalvinService.getCalvinChats(payload).then(response => {
				resolve(response.data)
			}).catch(error => { reject(error) })
		})
	},

	// eslint-disable-next-line no-unused-vars
	getCalvinChat({ commit }, payload) {
		return new Promise((resolve, reject) => {
			CalvinService.getCalvinChat(payload).then(response => {
				resolve(response.data)
			}).catch(error => { reject(error) })
		})
	},

	// eslint-disable-next-line no-unused-vars
	postCalvinChat({ commit }, payload) {
		return new Promise((resolve, reject) => {
			CalvinService.postCalvinChat(payload).then(response => {
				resolve(response.data)
			}).catch(error => { reject(error) })
		})
	},

	// eslint-disable-next-line no-unused-vars
	startCalvinWorkspace({ commit }, payload) {
		return new Promise((resolve, reject) => {
			CalvinService.startCalvinWorkspace(payload).then(response => {
				resolve(response.data)
			}).catch(error => { reject(error) })
		})
	},

	// eslint-disable-next-line no-unused-vars
	provisionCalvin({ commit }) {
		return new Promise((resolve, reject) => {
			CalvinService.provisionCalvin().then(response => {
				resolve(response.data)
			}).catch(error => { reject(error) })
		})
	}
}
